import React from "react";
import { Buttons } from "@danishagro/cms/src/components/Buttons/Buttons.component";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import {
    DA_Title,
    DA_TitleTag,
} from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { useBackgroundColor } from "@danishagro/cms/src/blocks/hooks/useBackgroundColor/useBackgroundColor.hook";
import { usePadding } from "@danishagro/cms/src/blocks/hooks/usePadding/usePadding.hook";
import { useWebsiteType } from "@danishagro/cms/src/hooks/useWebsiteType.hook";
import { TextProps } from "./Text.interface";
import { useAlignment } from "./hooks/useAlignment.hook";
import S from "./Text.module.scss";

const Text = (props: TextProps) => {
    const { websiteTypeClass } = useWebsiteType(S);

    const { backgroundColorClass, alternativeButtonTheme, hasBackgroundColor } = useBackgroundColor(
        props.backgroundColor
    );
    const { paddingClass } = usePadding(props.isCompact, hasBackgroundColor);
    const { alignmentClass, isAlignmentCenter } = useAlignment(props.alignment, S);

    return (
        <div
            className={cn(
                S.wrapper,
                paddingClass,
                backgroundColorClass,
                alignmentClass,
                websiteTypeClass
            )}
        >
            <DA_Container noVerticalPadding>
                <div className={S.inner}>
                    {/** Tagline */}
                    {props.tagline ? <span className={S.tagline}>{props.tagline}</span> : null}

                    {/** Title */}
                    {props.headline ? (
                        <DA_Title h2 tag={DA_TitleTag.H2} noMargin fullWidth>
                            {props.headline}
                        </DA_Title>
                    ) : null}

                    {/** Text */}
                    {props.text ? (
                        <DA_Text html={props.text} noPadding alignCenter={isAlignmentCenter} />
                    ) : null}

                    {/** Buttons */}
                    <Buttons buttons={props.buttons} theme={alternativeButtonTheme} />
                </div>
            </DA_Container>
        </div>
    );
};

export default Text;
